import OrderForm from './OrderForm.js?r=75';

document.querySelectorAll('.product-form').forEach(it =>{
  new OrderForm(it);
})

if(document.body.dataset.collection){
  fetch('/cart/update.js', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        'collection': document.body.dataset.collection,
        'flash': '',
      }
    }),
    
  }).then()
}